import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'qr-status-badge',
  templateUrl: './status-badge.component.html',
  styleUrls: ['./status-badge.component.css']
})
export class StatusBadgeComponent implements OnInit {
  @Input() status: string;
  
  statusConfig: any = {
    'CHO_XU_LY': { label: 'Chờ xử lý', colorClass: 'badge-warning' },
    'DA_PHAN_CONG': { label: 'Đã phân công', colorClass: 'badge-warning' },
    'DA_TIEP_NHAN': { label: 'Đã tiếp nhận', colorClass: 'badge-success' },
    'TU_CHOI': { label: 'Từ chối', colorClass: 'badge-danger' }
  };

  constructor() { }

  ngOnInit() {
  }
  
  get currentStatus() {
    return this.statusConfig[this.status] || { label: this.status, colorClass: 'badge-default' };
  }
}



// WEBPACK FOOTER //
// /app/src/app/components/status-badge/status-badge.component.ts